// extracted by mini-css-extract-plugin
export default {"baseLayerSelect":"SimpleEntityMap_baseLayerSelect__Ixlcx"};